var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBusiness = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#389F75"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 15C13 17.2091 14.7909 19 17 19C19.2091 19 21 17.2091 21 15C21 12.7909 19.2091 11 17 11C14.7909 11 13 12.7909 13 15ZM23 19C23 20.6569 24.3431 22 26 22C27.6569 22 29 20.6569 29 19C29 17.3431 27.6569 16 26 16C24.3431 16 23 17.3431 23 19Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9833 21C12.2619 21 8.38826 23.4265 8.00065 28.1992C7.97954 28.4592 8.47671 29 8.7275 29H25.2467C25.9979 29 26.0096 28.3955 25.9979 28.2C25.7049 23.2932 21.7712 21 16.9833 21ZM31.4559 29H27.6C27.6 26.7491 26.8563 24.6718 25.6012 23.0006C29.0077 23.0379 31.7892 24.7601 31.9985 28.4C32.0069 28.5466 31.9985 29 31.4559 29Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBusiness);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/business.svg";